import { observer } from "mobx-react-lite";
import { MdsVirtualizedItemList } from "@/design-system/components/item-list";
import { useTabPageStore } from "@/hooks/useTabPageStore";
import { TrashPageListEmpty } from "@/pages/trash/TrashPageListEmpty";

export const TrashPageList = observer(() => {
  const page = useTabPageStore("trashPage");

  if (!page.itemRows.length) {
    return <TrashPageListEmpty />;
  }

  return (
    <>
      <MdsVirtualizedItemList rows={page.itemRows} listState={page.listState} />
      {page.listState.multiSelectUi}
    </>
  );
});
